import { isHostedByTeamHub } from '../services/hostAuthService';

const CALENDAR_INTEGRATIONS_PLUGIN_ID = 'teamhub:header:integrations:calendar';
const INTEGRATIONS_DESTINATION = 'teamhub:header:integrations';

type IntegrationPlugin = {
  id?: string;
  plugin?: string;
  destination?: string;
};

type MfToolsModule = {
  EVENTS: {
    TEAMHUB_HEADER_INTEGRATIONS?: string;
    TEAMHUB_INTEGRATIONS_MODAL: string;
  };
  emitEvent: (event: string, payload?: unknown) => void;
  getPlugins?: (key: string) => IntegrationPlugin[];
};

const openStandaloneCalendarSettings = (): void => {
  window.dispatchEvent(
    new CustomEvent('open-settings-modal', {
      detail: { tab: 'calendar' },
    }),
  );
};

const openTeamHubCalendarIntegrations = async (): Promise<void> => {
  // Dynamic import keeps `@sng-pkgs/mftools` out of the standalone entry graph.
  // A static import trips Federation RUNTIME-006 when the MF bundle is opened
  // directly without a TeamHub host providing the shared package.
  const mftools = (await import('@sng-pkgs/mftools')) as unknown as MfToolsModule;
  const { EVENTS, emitEvent, getPlugins } = mftools;

  const integrationKey = EVENTS.TEAMHUB_HEADER_INTEGRATIONS || INTEGRATIONS_DESTINATION;
  const integrationPlugins = getPlugins?.(integrationKey) || [];
  const calendarPlugin = integrationPlugins.find(
    (plugin) => plugin?.id === CALENDAR_INTEGRATIONS_PLUGIN_ID,
  );

  emitEvent(EVENTS.TEAMHUB_INTEGRATIONS_MODAL, {
    data: calendarPlugin
      ? {
          ...calendarPlugin,
          plugin: calendarPlugin.plugin || INTEGRATIONS_DESTINATION,
          selectedId: calendarPlugin.id || CALENDAR_INTEGRATIONS_PLUGIN_ID,
        }
      : {
          plugin: INTEGRATIONS_DESTINATION,
          selectedId: CALENDAR_INTEGRATIONS_PLUGIN_ID,
        },
  });
};

/**
 * Open calendar connection UI.
 * - TeamHub/MF: Integrations modal with the Calendar plugin selected
 * - Standalone: Meet Settings modal on the Calendar tab
 */
export const openCalendarIntegrations = (): void => {
  if (!isHostedByTeamHub()) {
    openStandaloneCalendarSettings();
    return;
  }

  void openTeamHubCalendarIntegrations().catch((error) => {
    console.error('[openCalendarIntegrations] Failed to open TeamHub integrations', error);
  });
};
